export async function captureImage(videoElement) {
  if (!videoElement?.videoWidth || !videoElement?.videoHeight) {
    throw new Error('Camera chua san sang de chup anh');
  }

  const canvas = document.createElement('canvas');
  canvas.width = videoElement.videoWidth;
  canvas.height = videoElement.videoHeight;

  const context = canvas.getContext('2d');
  context.drawImage(videoElement, 0, 0);

  const blob = await new Promise((resolve) => {
    canvas.toBlob(resolve, 'image/jpeg', 0.92);
  });

  if (!blob) {
    throw new Error('Khong tao duoc anh chup');
  }

  return blob;
}

export function toAbsoluteMediaUrl(url) {
  if (!url || /^(blob:|data:|https?:)/.test(url)) {
    return url;
  }

  const baseUrl = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '') || '';
  return `${baseUrl}${url.startsWith('/') ? '' : '/'}${url}`;
}
